import React from "react";

import NormalTable, { IColumn,ITableRowData } from "../normal-table/normal-table";
import "./list-page.scss";
import EditableTable from "../editable-table/editable-table";
import TextInput from "../text-input/text-input";
import { useBack } from "../../utils/use-back";
import { IDetailPageData, IListPageData, typeIsIListPageData } from "../../utils/api";

import { BsArrowLeft } from "react-icons/bs";
import { FaPencilAlt } from "react-icons/fa";

import Tooltip from "../../../shared/components/tooltip/tooltip";

import { useState, useEffect } from "react";

import { getTheLastParam } from "../../utils/utils";

export interface IListPageConfig {
  title: string;
  columns: IColumn[];
  dataUrl: string;
  pageMode: string;
  modalColumns?: IColumn[];
  tooltipTxt?: string;
  fetchedData?: IDetailPageData | IListPageData;
  localDeleteOn?: boolean;
  allStatus?: string | null;
  allStatusPostError?: string | undefined;
  allStatusDelete?: string | null;
  allStatusTablePost?: string | null;
  allStatusPost?: string | null;
  allStatusError?: string | undefined;
  inputData?: string;
  toggleWarning?: boolean;
  unblockInput?: boolean;
  navigateToAfterSave?: string;
  uniqueKeys?: string[],
  hideButtons?: string[];
  hideCheckBoxes?: boolean;
  defaultSortCol?: string;
  revertAction?: boolean;
  linkedAlert?: string;
  noEmptyTable?: boolean;
  primaryKeyIsRequired?: boolean;
  revertAlltrigger?: undefined | boolean,
  revertFromParent?: undefined | ITableRowData,
  titleIsEditable?: boolean,
  renderPathButtons?: () => JSX.Element | undefined;
  renderExtraTableBtns?: () => JSX.Element;
  passChildDataToParent?: (data: ITableRowData[]) => void;
  timeframeStartTilEnd?: boolean;
  handleOnDelete?: (ids: string[]) => void;
  updateParentWithTheActualList?: (data: ITableRowData[]) => void;
  getInputValue?: (value: string, key?: string) => void;
  saveData?: (data: ITableRowData[], idsToBeDeleted?: string [], fullDataToBeDeleted?: ITableRowData[]) => void;
  getData?: (url: string) => void;
  generateTable?: (id: string) => void;
  onRowClickAction?:(id:string) => void;
  onTableScrollAction?:(offset:number) => void;
  renderExtraColumns?: (id: string, columnData?: string) => JSX.Element;
  renderExtraPopUpButtons?: (data: ITableRowData) => JSX.Element;
  recentlyDeletedFullFromParent?: ITableRowData[] | undefined;
  sortBy?: (searchQuesry: string) => void;
  isRowClickable? : boolean;
}

const ListPage = ({
  columns,
  inputData,
  toggleWarning,
  localDeleteOn,
  allStatus,
  noEmptyTable,
  linkedAlert,
  allStatusDelete,
  allStatusPost,
  allStatusError,
  allStatusTablePost,
  allStatusPostError,
  fetchedData,
  title,
  primaryKeyIsRequired,
  unblockInput,
  dataUrl,
  pageMode,
  tooltipTxt,
  uniqueKeys,
  modalColumns,
  timeframeStartTilEnd,
  hideButtons,
  hideCheckBoxes,
  navigateToAfterSave,
  defaultSortCol,
  revertAction,
  revertAlltrigger,
  recentlyDeletedFullFromParent,
  revertFromParent,
  titleIsEditable = true,
  passChildDataToParent,
  onTableScrollAction,
  renderExtraTableBtns,
  renderPathButtons,
  generateTable,
  getInputValue,
  handleOnDelete,
  saveData,
  onRowClickAction,
  updateParentWithTheActualList,
  renderExtraColumns,
  renderExtraPopUpButtons,
  getData,
  sortBy,
  isRowClickable
}: IListPageConfig) => {
  const [toggleShowInput, setToggleShowInput] = useState(false);
  const { handleBack } = useBack();

  useEffect(() => {
    if (getTheLastParam() === "new") {
      setToggleShowInput(true);
    }
  }, []);

  const renderEditableTable = () => {
    if (
      saveData &&
      ((fetchedData as IDetailPageData)?.rowData || fetchedData === undefined)
    ) {
      return (
        <EditableTable
          getData={getData}
          saveData={saveData}
          handleOnDelete={handleOnDelete}
          columns={columns}
          modalColumns={modalColumns}
          unblockInput={unblockInput}
          fetchedData={fetchedData as IDetailPageData}
          allStatus={allStatus}
          allStatusDelete={allStatusDelete}
          allStatusPost={allStatusPost}
          allStatusPostError={allStatusPostError}
          allStatusError={allStatusError}
          allStatusTablePost={allStatusTablePost}
          localDeleteOn={localDeleteOn}
          hideButtons={hideButtons || []}
          inputData={inputData}
          dataUrl={dataUrl}
          toggleShowInput={toggleShowInput}
          navigateToAfterSave={navigateToAfterSave}
          generateTable={generateTable}
          uniqueKeys={uniqueKeys}
          noEmptyTable={noEmptyTable}
          revertFromParent={revertFromParent}
          updateParentWithTheActualList={updateParentWithTheActualList}
          revertAction={revertAction}
          renderExtraPopUpButtons={renderExtraPopUpButtons}
          renderExtraTableBtns={renderExtraTableBtns}
          passChildDataToParent={passChildDataToParent}
          sortBy={sortBy}
          primaryKeyIsRequired={primaryKeyIsRequired}
          revertAlltrigger={revertAlltrigger}
          defaultSortCol={defaultSortCol}
          recentlyDeletedFullFromParent={recentlyDeletedFullFromParent}
        />
      );
    }
    return;
  };

  const renderNormalTable = () => {
    if (typeIsIListPageData(fetchedData) || !fetchedData) {
      return (
        <NormalTable
          handleOnDelete={handleOnDelete}
          columns={columns}
          fetchedData={fetchedData}
          unblockInput={unblockInput}
          allStatusDelete={allStatusDelete}
          allStatus={allStatus}
          hideButtons={hideButtons || []}
          dataUrl={dataUrl}
          onRowClickAction={onRowClickAction}
          renderExtraColumns={renderExtraColumns}
          timeframeStartTilEnd={timeframeStartTilEnd}
          renderExtraTableBtns={renderExtraTableBtns}
          sortBy={sortBy}
          hideCheckBoxes={hideCheckBoxes}
          defaultSortCol={defaultSortCol}
          onTableScrollAction={onTableScrollAction}
          isRowClickable={isRowClickable}
        />
      );
    }
    return undefined;
  };

  const renderInput = () => {
    if (getInputValue) {
      return (
        <div className="listPage-input">
          <TextInput
            type={"text"}
            id={"Input_field_name"}
            label={"Name"}
            autofocus={false}
            required={true}
            inputKey={"Input_field_name"}
            handleOnChange={getInputValue}
            controlled={true}
            value={inputData}
            toggleWarning={toggleWarning}
          />
        </div>
      );
    }
    return;
  };

  return (
    <div className="listPage">
      <div onClick={() => handleBack()} className="listPage-nav-btn">
        <BsArrowLeft />
      </div>

      <div className="listPage-header">
        {inputData && <h1>{inputData}
          {titleIsEditable && <FaPencilAlt onClick={() => setToggleShowInput((prev) => !prev)} className="listPage-edit"/>}
        </h1>}
        {inputData && linkedAlert && <span className="listPage-linkedAlertHeader">Linked AlertCase: {`${linkedAlert}`}</span>}

        {!inputData && title ? <div>
          <h1>
            {title}
            {tooltipTxt && <Tooltip content={tooltipTxt} direction="top" delay={350} />}
          </h1>
        </div> : ""}
        {renderPathButtons && renderPathButtons()}
      </div>

      {toggleShowInput && renderInput()}
      {pageMode === "editable" ? renderEditableTable() : renderNormalTable()}
    </div>
  );
};

export default ListPage;
